import { each } from 'lodash';
import Swiper from 'swiper/bundle';
export default class CarouselDesigners {
    constructor() {
        this.carousel = {
            elements: document.querySelectorAll('.carousel[data-carousel="designers"]'),
        }

        each(this.carousel.elements, (carousel) => {
            this.createCarousel(carousel); // Init Carousel
        });
    }

    createCarousel(target) {
        var carousel = new Swiper(target, {
            slidesPerView: 'auto',
            spaceBetween: 20,
            grabCursor: true,
            navigation: {
                nextEl: "[data-next]",
                prevEl: "[data-prev]",
            },
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
            },
        });

        if(!!target && target.querySelectorAll('.swiper-slide').length > 3){
            target.setAttribute('data-draggable',true)
        }
    }
}